// extracted by mini-css-extract-plugin
export var completionBody = "_lj-2";
export var completionCard = "_lj-0";
export var completionFooter = "_lj-3";
export var completionTitle = "_lj-1";